import type { CurrencyProfile } from '@tg/shared';

export function currencyIconSource(profile: CurrencyProfile): string {
  if (profile.icon === 'custom' && profile.image) return profile.image;
  // The schema restricts the ticker to ASCII capitals/digits.
  const mark = profile.icon === 'usdt' ? '₮' : profile.ticker[0];
  return `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="15" fill="#087e6b" stroke="#71f1cf"/><text x="16" y="22" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-weight="700" font-size="19">${mark}</text></svg>`)}`;
}
